import { render, staticRenderFns } from "./LandForm.vue?vue&type=template&id=51b1fa0f&"
import script from "./LandForm.vue?vue&type=script&lang=js&"
export * from "./LandForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports